import { useEffect } from "react";
import BleConexionModal from "../../Contexts/Ble/BleConexionModal";
import useBle from "../../Hooks/Ble";

/** Solicita conexión BLE al entrar a una pantalla de prueba (si aún no hay dispositivo). */
export default function RequiereBle({ children }) {
    const { dispositivo, sesionDesdeAtletas, solicitarConexionPrueba } = useBle();

    useEffect(() => {
        if (!dispositivo && !sesionDesdeAtletas) {
            solicitarConexionPrueba();
        }
    }, [dispositivo, sesionDesdeAtletas, solicitarConexionPrueba]);

    return (
        <>
            <BleConexionModal />
            {children}
        </>
    );
}
